import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { NotableGenerationProperties } from "onboarding/llm-analytics/_snippets/notable-generation-properties.tsx";
import * as React from 'react';
export default {
  OnboardingContentWrapper,
  NotableGenerationProperties,
  React
};